var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  viewBox: "0 0 33 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currenColor",
  fillRule: "evenodd",
  d: "M19.5 4.9c-1.773-1.467-4.227-1.467-6 0l-8.888 7.347c-.81.67-1.312 1.729-1.312 2.882v11.459c0 2.091 1.571 3.612 3.3 3.612h3.3v-5.366c0-3.721 2.861-6.912 6.6-6.912s6.6 3.191 6.6 6.912V30.2h3.3c1.729 0 3.3-1.52 3.3-3.612V15.129c0-1.153-.502-2.212-1.312-2.882zm2.104-2.544 8.886 7.348C32.092 11.028 33 13.035 33 15.13v11.459c0 3.72-2.861 6.912-6.6 6.912h-3.3a3.3 3.3 0 0 1-3.3-3.3v-5.366c0-2.091-1.571-3.612-3.3-3.612s-3.3 1.52-3.3 3.612V30.2a3.3 3.3 0 0 1-3.3 3.3H6.6c-3.739 0-6.6-3.191-6.6-6.912V15.129c0-2.094.908-4.101 2.51-5.425l8.887-7.348c2.993-2.475 7.213-2.475 10.207 0",
  clipRule: "evenodd"
})));
export default SvgHome;